import Vue from "vue";

export const toastMessage = function (message, duration = 3000) {
	Vue.toasted.show(message, {
		position: "bottom-center",
		duration: duration,
		action: {
			text: "Fermer",
			onClick: (e, toastObject) => {
				toastObject.goAway(0);
			}
		}
	});
};
